/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
import AutoCompleteTextField from 'material/autofilltext/autofilltext';



/* ========== ~~~~~~~~~~ REPORTS : ADDABLEEMAILLIST : ADDABLEEMAIL : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const AddableEmail = (props) => (
    <AutoCompleteTextField
        handleSelect={props.handleSelect}
        label={``} 
        type={`email`}
        list={props.allUsers}
        handleBlur = {props.handleBlur}
        value={props.value}
        valid={props.valid}
        name={`email`}
        required={props.required}
    />
);



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default AddableEmail;